
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinmumbai() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Mumbai ',
        heading: 'etravo : Corporate Cab Services in Mumbai ',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Mumbai, designed for businesses, MNCs, startups, and professionals who need seamless transportation for employee commuting, airport transfers, client meetings, and executive travel. With a fleet of well-maintained GPS-enabled vehicles and professional chauffeurs, eTravo ensures safe, punctual, and comfortable corporate mobility across Mumbai. Flexible hourly, daily, and monthly rental plans make it a trusted partner for corporate travel in the city.",

"top": "Top Corporate Cab Service Zones in Mumbai with eTravo",

"topPlaces": [
  {
    "title": "Bandra Kurla Complex (BKC)",
    "description": "Mumbai’s premier financial and corporate hub, home to global banks, MNCs, and corporate headquarters requiring premium employee and executive transport services."
  },
  {
    "title": "Andheri MIDC & SEEPZ",
    "description": "A major IT and industrial hub with offices, studios, and corporate parks requiring daily employee pickup and drop services."
  },
  {
    "title": "Lower Parel Business District",
    "description": "A fast-growing commercial zone with corporate towers, media houses, and financial firms needing reliable corporate cab services."
  },
  {
    "title": "Powai",
    "description": "A key IT and corporate residential hub hosting major tech companies and startups with high demand for employee commute solutions."
  },
  {
    "title": "Navi Mumbai (Vashi, Belapur, Airoli)",
    "description": "A growing corporate corridor with IT parks, business centers, and logistics hubs requiring structured employee transportation services."
  },
  {
    "title": "Thane Corporate Zone",
    "description": "A rapidly developing business district with IT companies and corporate offices needing daily commute and shuttle services."
  },
  {
    "title": "Nariman Point & Churchgate",
    "description": "Traditional financial districts of Mumbai hosting top law firms, banks, and corporate offices requiring executive travel services."
  },
  {
    "title": "Chandivali & Saki Naka",
    "description": "Important IT and commercial zones with studios, tech firms, and corporate offices requiring flexible cab rental solutions."
  },
  {
    "title": "Goregaon & Malad IT Parks",
    "description": "A western suburban corporate belt with IT companies and media houses needing reliable employee transportation services."
  },
  {
    "title": "Mumbai Airport (T2 & T1 Corridor)",
    "description": "A critical zone for corporate travel, handling VIP transfers, business arrivals, and executive airport pickup and drop services."
  }
],


"services": [
{
"name": "Corporate Cab Mumbai",
"description": "eTravo offers reliable corporate cab services in Mumbai designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily corporate commuting and meetings."
},
{
"name": "Corporate Taxi Mumbai",
"description": "Our corporate taxi services in Mumbai provide efficient and flexible transportation for businesses. eTravo ensures timely service, clean vehicles, and a seamless travel experience for executives and employees."
},
{
"name": "Company Cab Service Mumbai",
"description": "eTravo provides company cab services in Mumbai tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and convenience."
},
{
"name": "Office Transport Mumbai",
"description": "Simplify daily commuting with eTravo’s office transport services in Mumbai. We offer structured and dependable transportation solutions for employees across all major business areas."
},
{
"name": "Employee Cab Mumbai",
"description": "Our employee cab services in Mumbai are designed for safe and punctual workforce mobility. eTravo ensures well-planned routes and comfortable rides for daily commuting."
},
{
"name": "Corporate Travel Mumbai",
"description": "eTravo offers complete corporate travel services in Mumbai for both local and outstation needs. Our service ensures smooth and reliable travel for executives and business teams."
},
{
"name": "Business Cab Mumbai",
"description": "eTravo’s business cab services in Mumbai are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality, comfort, and professional travel experiences."
},
{
"name": "Staff Transport Mumbai",
"description": "eTravo provides dependable staff transport services in Mumbai for daily employee commuting. Our service ensures timely pickups, safe travel, and efficient coordination."
},
{
"name": "Corporate Fleet Mumbai",
"description": "eTravo offers corporate fleet services in Mumbai for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and smooth transportation operations."
},
{
"name": "Company Taxi Mumbai",
"description": "Our company taxi services in Mumbai provide flexible and convenient transport options for businesses. eTravo ensures reliable travel for employees, clients, and executives."
},
{
"name": "Corporate Pickup Drop Mumbai",
"description": "eTravo provides corporate pickup and drop services in Mumbai for efficient employee commuting. Our service ensures punctual scheduling and comfortable rides for daily travel."
},
{
"name": "Business Travel Cab Mumbai",
"description": "Our business travel cab services in Mumbai are designed for professionals traveling for meetings and corporate activities. eTravo ensures smooth, reliable, and comfortable journeys."
},
{
"name": "Office Cab Booking Mumbai",
"description": "eTravo offers easy office cab booking services in Mumbai with reliable and timely transportation. Our service ensures hassle-free travel for employees and corporate teams."
},
{
"name": "Corporate Commute Mumbai",
"description": "eTravo’s corporate commute services in Mumbai provide structured and efficient employee transportation. Our service ensures smooth daily travel with reliable vehicles and drivers."
},
{
"name": "Professional Cab Service Mumbai",
"description": "eTravo provides professional cab services in Mumbai designed to meet corporate standards. With trained drivers and well-maintained vehicles, we ensure safe, comfortable, and reliable travel."
}
],
"tableData": [
["Corporate Cab Mumbai", "Corporate Taxi Mumbai"],
["Company Cab Service Mumbai", "Office Transport Mumbai"],
["Employee Cab Mumbai", "Corporate Travel Mumbai"],
["Business Cab Mumbai", "Staff Transport Mumbai"],
["Corporate Fleet Mumbai", "Company Taxi Mumbai"],
["Corporate Pickup Drop Mumbai", "Business Travel Cab Mumbai"],
["Office Cab Booking Mumbai", "Corporate Commute Mumbai"],
["Professional Cab Service Mumbai", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Mumbai",
      "WhyChoosedescription": "eTravo offers professional corporate cab services in Mumbai, ensuring smooth and efficient transportation for employees, executives, and business clients across key business hubs like BKC, Andheri, Powai, and Navi Mumbai."
    },
    {
      "WhyChooseheading": "Comprehensive Corporate Travel Solutions",
      "WhyChoosedescription": "Corporate cab services in Mumbai include employee transportation, airport transfers, executive travel, and long-term rentals, providing complete mobility solutions for businesses. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "On-Time Pickup and Drop for Employees",
      "WhyChoosedescription": "With fixed routes and structured schedules, corporate cab services ensure timely pickup and drop, helping employees reach offices without delays and improving productivity. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Needs",
      "WhyChoosedescription": "From hatchbacks and sedans to SUVs and luxury vehicles, corporate cab providers offer a diverse fleet to meet daily commute, executive travel, and VIP transport requirements. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Corporate Etiquette",
      "WhyChoosedescription": "Experienced drivers ensure safe, smooth, and professional travel, maintaining punctuality and high service standards for business travel."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Businesses",
      "WhyChoosedescription": "Corporate cab services offer hourly, daily, monthly, and long-term rental options, allowing companies to customize travel solutions based on their operational needs. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet Management",
      "WhyChoosedescription": "Modern corporate cab services use GPS tracking, real-time monitoring, and route optimization systems to ensure safety, efficiency, and transparency in employee transportation. :contentReference[oaicite:4]{index=4}"
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel",
      "WhyChoosedescription": "Dedicated support teams operate round the clock to manage bookings, last-minute changes, and emergency travel needs, ensuring uninterrupted business operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Mumbai?',
            answer: 'Corporate cab services in Mumbai provide organized transportation for employees, executives, and clients including daily office commute, airport transfers, and business travel.',
        },
        {
            question: 'What services are included in corporate cab services?',
            answer: 'Services include employee transport, executive travel, airport pickup and drop, outstation travel, and long-term corporate rentals. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Do corporate cab services provide daily office pickup and drop?',
            answer: 'Yes, corporate cab services offer structured daily pickup and drop services with fixed routes and schedules for employees. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Are corporate cab services available 24/7 in Mumbai?',
            answer: 'Yes, most corporate cab providers operate round the clock to support business travel and shift-based employee transportation.',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Corporate fleets include hatchbacks, sedans, SUVs, and luxury cars depending on employee and executive travel needs. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, they include GPS tracking, verified drivers, and safety protocols to ensure secure and reliable travel. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'Can corporate cab services be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on their workforce requirements.',
        },
        {
            question: 'Do corporate cab services offer monthly contracts?',
            answer: 'Yes, many providers offer cost-effective monthly and long-term contracts for corporate transportation.',
        },
        {
            question: 'Are corporate cab services suitable for airport transfers?',
            answer: 'Yes, they provide seamless airport pickup and drop services for employees, executives, and clients.',
        },
        {
            question: 'How can I book corporate cab services in Mumbai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Karan Mehta',
        designation: 'Operations Head, Corporate Firm, Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab services in Mumbai. Their punctual service and professional drivers ensure smooth daily operations for our team.”',
    },
    {
        name: 'Ms. Riya Shah',
        designation: 'HR Manager, IT Company, Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transportation in Mumbai. Their flexible plans and reliable service make them our preferred corporate travel partner.”',
    },
];









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-mumbai.jpg",
  "description": "Reliable corporate cab services in Mumbai by eTravo. Ideal for employee transport, office pickup and drop, business travel, and corporate fleet management with safe and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab Services in Mumbai | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Mumbai with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Reliable and safe rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/138.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinmumbai;